document.addEventListener('DOMContentLoaded', function () {
/*
  const whatDevice2 = /iPad|iPhone|iPod/.test(navigator.userAgent);
let whatEventUse2 = whatDevice2 ? 'touchstart' : 'click';
*/

  var discountBlocks = document.querySelectorAll('.quantity_discount-block');
  const selectorInput = document.querySelector('.quantity-selector input');
  const salePriceField = document.querySelector('.product-info sale-price');
  const unitPrice = document.querySelector('.product-info unit-price');
  const savedAmount = document.querySelector('.saved_amount');
  const mainPrice = document.querySelector('.product-info__price sale-price');
  // Test for Button Connect
  const quantitySelector = document.querySelector('.product-info__quantity-selector  quantity-selector');
  const quantityButtons = quantitySelector.querySelectorAll('button');
  const quantityInput = document.querySelector('.quantity-selector input');
  const quantityButtonFirst = quantityButtons[0];
  const quantityButtonLast = quantityButtons[1];
  // ENDE Test for Button Connect
    
/*  
  const dynamicData = {
    discountInfo: {{ product.metafields.pennywise.discounts_volume_selection.value | json }}
  };
*/

    // Get the product metafields data from the data attribute
    var productMetaDataElement = document.getElementById('dynamic-data');
    var productMetaData = JSON.parse(productMetaDataElement.textContent);  

    // Assign productData to the product variable
    const dynamicData = {
        discountInfo: productMetaData
    };
  

  
// Get the product data from the hidden div
var productDataElement = document.getElementById('product-data');
var productData = JSON.parse(productDataElement.textContent);

// Assign productData to the product variable
const product = {
    productInfo: productData
};


function applyDiscountLogic() {
  if (dynamicData.discountInfo != null) {
    const unitPriceText = unitPrice.innerHTML;
    const originalPriceMatch = unitPriceText.match(/(?<=€)([^/]+)/); 
    const originalPrice = originalPriceMatch ? parseFloat(originalPriceMatch[1].replace(',', '.')) : null;

    discountBlocks.forEach((block) => {
      block.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopImmediatePropagation();
        
        block.classList.toggle('isActive', true);
        discountBlocks.forEach((sibling) => {
          if (sibling !== block) {
            sibling.classList.remove('isActive');
          }
        });

        const quantity = parseInt(block.getAttribute('data-quantity'));
        selectorInput.value = quantity;

        const productPrice = product.productInfo.price / 100;
        let discountedPrice = productPrice;
        let regularPrice = productPrice;
        let discountPercentage;

        dynamicData.discountInfo.discounts.forEach((discount) => {
          if (quantity >= discount.quantity) {
            discountPercentage = discount.percentage;
            discountedPrice = (productPrice - (productPrice * (discountPercentage / 100))) * quantity;
            regularPrice = productPrice * quantity;
          }
        });

salePriceField.textContent = '€' + discountedPrice.toFixed(2).replace('.', ',') + ' ';
var span = document.createElement('span');
span.className = 'crossed text-subdued line-through';
span.textContent = '€' + regularPrice.toFixed(2).replace('.', ',');
salePriceField.appendChild(span);

        if (originalPrice !== null) {
          if (discountPercentage !== undefined) {
            const updatedPrice = originalPrice - (originalPrice * (discountPercentage / 100));
            unitPrice.textContent = unitPriceText.replace(originalPriceMatch[1], updatedPrice.toFixed(2).replace('.', ','));
          } else {
            unitPrice.innerHTML = unitPriceText;
          }
        }

        const crossedSpan = document.querySelector('.crossed');
        if (quantity === 1) {
          crossedSpan.classList.add('hidden');
        } else {
          crossedSpan.classList.remove('hidden');
        }

        const priceDifference = regularPrice - discountedPrice;
        savedAmount.innerHTML = `Spare €${priceDifference.toFixed(2).replace('.', ',')}`;

        if (priceDifference > 0) {
          savedAmount.classList.remove('hidden');
          mainPrice.classList.add('text-on-sale');
        } else {
          savedAmount.classList.add('hidden');
          mainPrice.classList.remove('text-on-sale');
        }
      });
    });
  } else {
    discountBlocks.forEach((block) => {
      block.addEventListener('click', function () {
        block.classList.toggle('isActive', true);
        discountBlocks.forEach((sibling) => {
          if (sibling !== block) {
            sibling.classList.remove('isActive');
          }
        });

        const quantity = parseInt(block.getAttribute('data-quantity'));
        selectorInput.value = quantity;
        const productPrice = product.productInfo.price / 100;
        mainPrice.innerHTML = '€' + (productPrice * quantity).toFixed(2).replace('.', ',');
      });
    });
  }
}

// Call the function to run the logic
applyDiscountLogic();
  


    var Qbuttons = document.querySelectorAll('.quantity-selector__button');

    const QsalePriceField = document.querySelector('.product-info sale-price');
      var productUnitPrice = product.productInfo.variants[0].unit_price;
      productUnitPrice = productUnitPrice / 100;
      const productPrice = product.productInfo.price / 100;
      let discountedPrice = productPrice;
      let regularPrice = productPrice;
      let discountPercentage;
      const UpdatedsalePriceField = document.querySelector('.product-info sale-price');





  
 Qbuttons.forEach(function(Qbutton) {
        Qbutton.addEventListener('click', function() {          
          
        var Qquantity = document.querySelector('.product-info__quantity-selector input').value;
discountPercentage = 0;
  if (dynamicData.discountInfo != null) {

    const unitPriceText = unitPrice.innerHTML;
    const originalPriceMatch = unitPriceText.match(/(?<=€)([^/]+)/); 
    const originalPrice = originalPriceMatch ? parseFloat(originalPriceMatch[1].replace(',', '.')) : null;

    
        dynamicData.discountInfo.discounts.forEach((discount) => {
          if (Qquantity >= discount.quantity) {            
            discountPercentage = discount.percentage;
            discountedPrice = (productPrice - (productPrice * (discountPercentage / 100))) * Qquantity;
            regularPrice = productPrice * Qquantity;
          }
         });
    if (discountPercentage != 0) {
    salePriceField.innerHTML = '€' + discountedPrice.toFixed(2).replace('.', ',') + ' ' + '<span class="crossed text-subdued line-through">' + '€' + regularPrice.toFixed(2).replace('.', ',') ;

            if (originalPrice !== null) {
              if (discountPercentage !== undefined) {
                const updatedPrice = productUnitPrice - (productUnitPrice * (discountPercentage / 100));
                unitPrice.innerHTML = unitPriceText.replace(originalPriceMatch[1], updatedPrice.toFixed(2).replace('.', ','));
              } else {
                unitPrice.innerHTML = unitPriceText;                
              }
            }

              
            const crossedSpan = document.querySelector('.crossed');
            if (Qquantity === 1) {
              crossedSpan.classList.add('hidden');
            } else {
              crossedSpan.classList.remove('hidden');
            }
    
            const priceDifference = regularPrice - discountedPrice;
            savedAmount.innerHTML = `Spare €${priceDifference.toFixed(2).replace('.', ',')}`;
    
            if (priceDifference > 0) {
              savedAmount.classList.remove('hidden');
              mainPrice.classList.add('text-on-sale');
            } else {
              savedAmount.classList.add('hidden');
              mainPrice.classList.remove('text-on-sale');
            }
              
      } else {
      
        var UpdatedPrice = Qquantity * productPrice;
        var UpdatedPriceWithCurrency = '€' + UpdatedPrice.toFixed(2).replace('.', ',');   
          salePriceField.innerHTML = UpdatedPriceWithCurrency;      
          salePriceField.classList.remove('text-on-sale');    
          savedAmount.classList.add('hidden');
          const updatedPrice = productUnitPrice;
          unitPrice.innerHTML = unitPriceText.replace(originalPriceMatch[1], updatedPrice.toFixed(2).replace('.', ','));
    }
        
     
        
  } else {
        var quantity = document.querySelector('.product-info__quantity-selector input').value;    
        var compareAtPrice = document.querySelector('compare-at-price').innerHTML;

    
        selectorInput.value = quantity;
    
        const productPrice = product.productInfo.price / 100;
    

        var initialPrice = product.productInfo.compare_at_price;

        if (initialPrice != null) {
          initialPrice = initialPrice / 100;
          initialPrice = initialPrice * quantity;
          // Parse the price as a floating-point number          
          // Round the price to two decimal places
          initialPrice = initialPrice.toFixed(2);
          initialPrice = initialPrice.replace('.', ',');

          var compareAtPriceValue = compareAtPrice.match(/€([\d.,]+)/)[1];
          var updatedPrice = compareAtPrice.replace(compareAtPriceValue, initialPrice);

          var onSaleBadge = document.querySelector('on-sale-badge').innerHTML;
          var savePriceValue = onSaleBadge.match(/€([\d.,]+)/)[1];          
          var savePrice = product.productInfo.compare_at_price - product.productInfo.price;
          savePrice = savePrice / 100;   
          document.querySelector('on-sale-badge').innerHTML = 'Spare €' + (savePrice * quantity).toFixed(2).replace('.', ',');
          document.querySelector('compare-at-price').innerHTML = updatedPrice;  
          
        }        
          
        mainPrice.innerHTML = '€' + (productPrice * quantity).toFixed(2).replace('.', ',');

  }
        });
      
    });


});